// Experience assets under /public/experience are served immutable (1-year
// Cache-Control, see next.config.ts headers). They have unhashed filenames, so
// the version query string below is what busts the cache: bump it whenever any
// /experience/* asset's BYTES change (e.g. a re-exported ab-wolf.glb).
export const EXPERIENCE_ASSET_VERSION = "2";

/** Versioned, immutable-cacheable URL for a /public/experience asset. */
export const expAsset = (file: string) => `/experience/${file}?v=${EXPERIENCE_ASSET_VERSION}`;
